import { CascadingMenu, type ICascadingMenuProps } from "@surfaces/CascadingMenu";
import { FollowUpMenuPopper, classes } from "./styles";

export interface IMenuProposeSocialOfferProps {
  anchorEl: HTMLElement | null;
  items: ICascadingMenuProps["items"];
}

export const MenuProposeSocialOffer = ({ anchorEl, items }: IMenuProposeSocialOfferProps) => {
  return (
    <FollowUpMenuPopper className={classes.root} anchorEl={anchorEl} placement="bottom-end" open={Boolean(anchorEl)}>
      <CascadingMenu items={items} />
    </FollowUpMenuPopper>
  );
};
